import { roundToScale } from './roundToScale'
import { roundBillingCents, roundBillingQuantity, roundBillingRands } from '@/shared'

type Input = { quantity: number } & ({ rateInRands: number } | { rateInCents: number })

export function calculateBillingLineItemTotalInRands(input: Input) {
  const rateInRands = 'rateInRands' in input ? input.rateInRands : input.rateInCents / 100

  return roundToScale(roundBillingQuantity(input.quantity) * roundBillingRands(rateInRands), 2)
}

export function calculateBillingLineItemTotalInCents(input: Input) {
  const rateInCents = 'rateInCents' in input ? input.rateInCents : input.rateInRands * 100

  return Math.round(roundBillingQuantity(input.quantity) * roundBillingCents(rateInCents))
}
